import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginComponent from '../views/login/login.component.vue'
import MainLayoutComponent from '../views/main-layout/main-layout.component.vue'
import PrivateAreaLayoutComponent from '../views/private-area-layout/private-area-layout.component.vue'
import PublicLayoutComponent from '../views/public-layout/public-layout.component.vue';
import { itiRouterGuardService } from '@/iti-core-vue';
import AuthCallbackComponent from '@/views/auth-callback/auth-callback.component.vue';
import { ItiRouterView } from '@/iti-core-vuetify';


Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginComponent
  },
  {
    path: '/call-back',
    name: 'callback',
    component: AuthCallbackComponent
  },
  {
    path: '/',
    redirect: '/inicio',
    name: 'public',
    component: PublicLayoutComponent,
    children: [
      {
        path: 'inicio',
        name: 'Inicio',
        component: () => import('@/views/publico/inicio/inicio-web.vue'),
      },
      {
        path: 'inicio/search',
        name: 'buscador',
        component: () => import('@/views/publico/inicio/search/inicio-search.vue'),
      },
      {
        path: 'NoticiaCompleta/:id',
        name: 'NoticiaCompleta',
        props: true,
        component: () => import('@/views/publico/noticias/noticias-web.vue'),
      },
      {
        path: 'actualidad',
        name: 'Noticias',
        component: () => import('@/views/publico/noticias/lista/noticias-web-lista.vue'),
      },
      {
        path: 'proyecto',
        name: 'Proyecto',
        component: () => import('@/views/publico/proyecto/proyecto-web.vue'),
      },
      {
        path: 'simbiosis',
        name: 'Simbiosis',
        component: () => import('@/views/publico/simbiosis/simbiosis-web.vue'),
      },
      {
        path: 'casos',
        name: 'Casos',
        component: () => import('@/views/publico/casos-exito/casos.vue'),
      },
      {
        path: 'casos/neumaticos',
        name: 'CasoNeumaticos',
        component: () => import('@/views/publico/casos-exito/casos/neumaticos/caso-neumaticos-web.vue'),
      },
      {
        path: 'casos/ladrillos',
        name: 'CasoLadrillos',
        component: () => import('@/views/publico/casos-exito/casos/ladrillos/caso-ladrillos-web.vue'),
      },
      {
        path: 'casos/lodos',
        name: 'CasoLodos',
        component: () => import('@/views/publico/casos-exito/casos/lodos/caso-lados-web.vue'),
      },
      {
        path: 'casos/alcoholera',
        name: 'CasoAlcoholera',
        component: () => import('@/views/publico/casos-exito/casos/alcoholera/alcoholera-web.vue'),
      },
      {
        path: 'casos/maderaCaucho',
        name: 'MaderaCaucho',
        component: () => import('@/views/publico/casos-exito/casos/madera-caucho/caso-madera-caucho-web.vue'),
      },
      {
        path: 'casos/Cerveza',
        name: 'Cerveza',
        component: () => import('@/views/publico/casos-exito/casos/cerveza/cerveza-web.vue'),
      },
      {
        path: 'demostrador',
        name: 'Demostrador',
        component: () => import('@/views/publico/demostrador/demostrador.vue'),
      },
      {
        path: 'demostrador/construccion',
        name: 'MuestraConstruccion',
        component: () => import('@/views/publico/demostrador/muestras/construccion/muestra-construccion.vue'),
      },
      {
        path: 'demostrador/Agroalimentario',
        name: 'Agroalimentario',
        component: () => import('@/views/publico/demostrador/agroalimentario/agroalimentario.vue'),
      },
      {
        path: 'demostrador/Disolventes',
        name: 'Disolventes',
        component: () => import('@/views/publico/demostrador/disolventes/disolventes.vue'),
      },
      {
        path: 'privacidad',
        name: 'Privacidad',
        component: () => import('@/views/publico/privacidad/privacidad-web.vue'),
      },
      {
        path: 'aviso-legal',
        name: 'AvisoLegal',
        component: () => import('@/views/publico/avisoLegal/avisoLegal-web.vue'),
      },
      {
        path: 'cookies',
        name: 'Cookies',
        component: () => import('@/views/publico/cookies/cookies-web.vue'),
      },
      {
        path: 'inicio/login',
        name: 'LoginPublico',
        component: () => import('@/views/public-login/public-login.component.vue'),
      },
    ]
  },
  {
    // path: '/main',
    // name: 'main',
    // redirect: '/main/home',
    // component: MainLayoutComponent,
    path: '/main',
    name: 'main',
    redirect: '/main/home',
    component: PrivateAreaLayoutComponent,
    beforeEnter: itiRouterGuardService.beforeEnter,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/offers-demands/offers-demands-list/offers-demands-list.vue'),
        //component: () => import('@/views/home/home.vue'),
      },
      {
        path: 'roles/lista',
        name: 'RolesLista',
        component: () => import('@/views/maestros/roles/lista/roles-lista.vue'),
      },
      {
        path: 'users/list',
        name: 'Users',
        component: () => import('@/views/maestros/usuarios/list/user-list.vue'),
      },
      {
        path: 'editarUsuarioFormulario/:id',
        name: 'EditarUsuarioFormulario',
        props: true,
        component: () => import('@/views/maestros/usuarios/form/user-form.vue'),
      },
      {
        path: 'tareas-programadas/lista',
        name: 'TareasProgramadasLista',
        component: () => import('@/views/maestros/scheduled-tasks/list/iti-scheduled-tasks-list.vue'),
      },
      {

        path: 'formulario',
        name: 'Formulario', //'formulario',
        component: () => import('@/views/maestros/formulario/formulario.vue'),
      },
      {
        path: 'calendario',
        name: 'Calendario',
        component: () => import('@/components/calendario/calendario.vue'),
      },
      {
        path: 'calendario/:collaborativeAreaId',
        name: 'CalendarioAreaColaborativa',
        component: () => import('@/components/calendario/calendario.vue'),
      },
      {
        path: 'area-colaborativa-gestion-documental',
        name: 'GestionDocumental',
        props: true,
        component: () => import('@/views/fileManager/fileManager.vue'),
      },
      {
        path: 'area-colaborativa-gestion-documental/:collaborativeAreaId',
        name: 'GestionDocumentalAreaColaborativa',
        props: true,
        component: () => import('@/views/fileManager/fileManager.vue'),
      },
      {
        path: 'buscador-avanzado',
        name: 'BuscadorAvanzado',
        component: () => import('@/views/advanced-search/advanced-search.vue'),
      },
      {
        path: 'cnae',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'Cnae',
            component: () =>
              import('@/views/maestros/cnae/list/cnae-list.vue'),
          },
        ],
      },
      {
        path: 'ler',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'Ler',
            component: () =>
              import('@/views/maestros/ler/list/ler-list.vue'),
          },
        ],
      },
      {
        path: 'sector',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'Sector',
            component: () =>
              import('@/views/maestros/sector/list/sector-list.vue'),
          },
        ],
      },
      {
        path: 'unit-type',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'UnitType',
            component: () =>
              import('@/views/maestros/unit-type/list/unit-type-list.vue'),
          },
        ],
      },
      {
        path: 'association',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'Association',
            component: () =>
              import('@/views/maestros/association/list/association-list.vue'),
          },
        ],
      },
      {
        path: 'category-first-level',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'CategoryFirstLevel',
            component: () =>
              import('@/views/maestros/category/first-level/list/category-first-level-list.vue'),
          },
        ],
      },
      {
        path: 'category-second-level',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'CategorySecondLevel',
            component: () =>
              import('@/views/maestros/category/second-level/list/category-second-level-list.vue'),
          },
        ],
      },
      {
        path: 'category-third-level',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'CategoryThirdLevel',
            component: () =>
              import('@/views/maestros/category/third-level/list/category-third-level-list.vue'),
          },
        ],
      },
      {
        path: 'category-fourth-level',
        component: ItiRouterView,
        children: [
          {
            path: 'list',
            name: 'CategoryFourthLevel',
            component: () =>
              import('@/views/maestros/category/fourth-level/list/category-fourth-level-list.vue'),
          },
        ],
      },
      {
        path: 'listaAlgoritmos',
        name: 'ListaAlgoritmos',
        component: () => import('@/views/algorithm/lista/listaAlgoritmos.vue'),
      },
      {
        path: 'OfertaDemandaFormulario',
        name: 'OfertaDemandaFormulario',
        props: true,
        component: () => import('@/views/offers-demands/offers-demand-form/offers-demands-form.vue'),
      },
      {
        path: 'algoritmo/:id',
        name: 'AlgoritmoFormulario',
        props: true,
        component: () => import('@/views/algorithm/formulario/algoritmoFormulario.vue'),
      },
      {
        path: 'listaPlantillas',
        name: 'ListaPlantillas',
        component: () => import('@/views/plantillas/lista/listaPlantillas.vue'),
      },
      {
        path: 'plantilla/:id',
        name: 'PlantillaFormulario',
        props: true,
        component: () => import('@/views/plantillas/formulario/plantillaFormulario.vue'),
      },
      {
        path: 'plantilla/:id/explorar',
        name: 'ListaVersiones',
        props: true,
        component: () => import('@/views/plantilla-version/lista/listaVersiones.vue'),
      },
      {
        path: 'plantilla/:idPlantilla/version/:idVersion',
        name: 'VersionFormulario',
        props: true,
        component: () => import('@/views/plantilla-version/formulario/versionesFormulario.vue'),
      },
      {
        path: 'plantilla/:idPlantilla/version/:idVersion/explorar',
        name: 'ExplorarVersion',
        props: true,
        component: () => import('@/views/plantilla-version/explorar/explorarVersion.vue'),
      },
      {
        // path: 'nuevoCampoFormulario/:idTemplate/:idField',
        path: 'plantilla/:idPlantilla/version/:idVersion/campo/:idCampo',
        name: 'NuevoCampoFormulario',
        props: true,
        component: () => import('@/views/plantillas/nuevoCampoFormulario/nuevoCampoFormulario.vue'),
      },
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/maestros/advanced-chat/advanced-chat.vue'),
      },
      {
        path: 'chat-una-sala/:id',
        name: 'ChatUnaSala',
        props: true,
        component: () => import('@/views/maestros/advanced-chat-una-sala/advanced-chat-una-sala.vue'),
      },
      {
        path: 'create-chat',
        name: 'CreateChat',
        component: () => import('@/views/maestros/create-chat/create-chat.vue'),
      },
      {
        path: 'notificaciones',
        name: 'Notificaciones',
        component: () => import('@/views/maestros/notificaciones/notificaciones.vue'),
      },
      {
        path: 'notificacionFormulario',
        name: 'NotificacionFormulario',
        component: () => import('@/views/maestros/notificacion-formulario/notificacion-formulario.vue'),
      },
      {
        path: 'areasPublicas',
        name: 'areasPublicas',
        component: () => import('@/views/collaborativeAreas/collaborativeAreaInfo/collaborativeAreaInfo.vue'),
      },
      {
        path: 'gruposTrabajo',
        name: 'gruposTrabajo',
        component: () => import('@/views/collaborativeAreas/collaborativeAreaInfo/collaborativeAreaInfo.vue'),
      },
      {
        path: 'areasColaborativas',
        name: 'areasColaborativas',
        component: () => import('@/views/collaborativeAreas/collaborativeAreaInfo/collaborativeAreaInfo.vue'),
      },
      {
        path: 'collaborativeAreaDetails/:id',
        name: 'CollaborativeAreaDetails',
        props: true,
        component: () => import('@/views/collaborativeAreas/collaborativeAreaDetails/collaborativeAreaDetails.vue'),
      },
      {
        path: 'collaborativeAreaForm/:id',
        name: 'CollaborativeAreaForm',
        props: true,
        component: () => import('@/views/collaborativeAreas/collaborativeAreaForm/collaborativeAreaForm.vue'),
      },
      {
        path: 'listadoOfertasDemandas',
        name: 'ListadoOfertasDemandas',
        component: () => import('@/views/offers-demands/offers-demands-list/offers-demands-list.vue'),
      },
      {
        path: 'matchingOferta_Demanda/:type/:id',
        name: 'MatchingOferta_Demanda',
        props: true,
        component: () => import('@/views/offers-demands/matchings/offer-demand-matching.vue'),
      },
      {
        path: 'foro/:ambitId',
        name: 'Foro',
        props: true,
        component: () => import('@/views/forum/forum-layout/forum-layout.component.vue'),
      },
      {
        path: 'foro/:ambitId/form',
        name: 'Foro-Forumlario',
        props: true,
        component: () => import('@/views/forum/forum-formulario/forum-formulario.component.vue'),
      },
      {
        path: 'foro/:ambitId/post/:postId',
        name: 'Foro-Post',
        props: true,
        component: () => import('@/views/forum/forum-post/forum-post.vue'),
      },
      {
        path: 'cuenta',
        name: 'Cuenta',
        props: true,
        component: () => import('@/views/user-account/user-account.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router;
